var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
import JobillaSpaApplication from 'common/JobillaSpaApplication';
var embed = Quill.import('blots/embed');
var PrivacyPolicyLink = /** @class */ (function (_super) {
    __extends(PrivacyPolicyLink, _super);
    function PrivacyPolicyLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivacyPolicyLink.create = function (text) {
        var store = new JobillaSpaApplication().vuexStore;
        var node = _super.create.call(this);
        node.innerText = text;
        node.setAttribute('target', '_blank');
        node.setAttribute('href', store.getters.privacyPolicy);
        node.classList.add('text-blue', 'font-semibold');
        return node;
    };
    PrivacyPolicyLink.value = function (node) {
        return node.innerText;
    };
    PrivacyPolicyLink.blotName = 'PrivacyPolicyLink';
    PrivacyPolicyLink.className = 'ql-policy-link';
    PrivacyPolicyLink.tagName = 'a';
    return PrivacyPolicyLink;
}(embed));
export { PrivacyPolicyLink };
